export default {
    auth: {
        attendance_success: "📅 Проверка посещаемости завершена! (Daily Rewards)\nПолучен бонус сегодня +50 баллов!",
        signup_bonus: "Регистрация успешна! 🎉\nПолучен приветственный бонус +100 баллов!",
        referral_bonus: "Регистрация по приглашению завершена! 🤝\nПриветственный бонус 100P + Реферальный бонус 500P\nВсего начислено 600 баллов!",
        login_required: "Требуется вход"
    },
    social: {
        subscribe_on: "Добавлено в список подписок.",
        subscribe_off: "Подписка отменена.",
        like_on: "Нравится!",
        like_off: "Нравится отменено.",
        follow_on: "Подписан.",
        follow_off: "Отписан."
    },
    comment: {
        submit_success: "Комментарий опубликован.",
        delete_confirm: "Вы действительно хотите удалить это?",
        delete_success: "Удалено.",
        delete_error: "Ошибка удаления",
        submit_error: "Ошибка публикации комментария",
        empty_error: "Пожалуйста, введите текст."
    },
    payment: {
        verify_success: "Проверка завершена!\nНачислено {amount} Звезд.",
        verify_fail: "Ошибка проверки",
        user_cancel: "Оплата отменена.",
        error: "Ошибка оплаты"
    },
    common: {
        confirm: "Подтвердить",
        cancel: "Отмена",
        close: "Закрыть",
        save: "Сохранить",
        delete: "Удалить",
        edit: "Редактировать",
        copy: "Копировать",
        loading: "Загрузка...",
        error: "Произошла ошибка.",
        success: "Успешно.",
        webtoon: "Вебтун",
        webnovel: "Веб-новелла",
        cinenovel: "Кино-новелла",
        published: "Опубликовано",
        draft: "Черновик",
        editor: "Редактор"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        report: "Центр жалоб",
        biz_ceo: "Ген. директор",
        biz_addr: "Адрес",
        biz_tel: "Поддержка",
        biz_email: "Email",
        biz_license: "Лицензия",
        biz_mail_order: "E-Commerce",
        biz_none: "Информация отсутствует",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "Главная",
        webtoon: "Вебтун",
        webnovel: "Веб-новелла",
        novel: "Веб-новелла",
        davinci: "Да Винчи",
        studio: "Студия авторов",
        library: "Библиотека",
        support: "Поддержка",
        admin: "Админка",
        config: "Внешние ссылки",
        factory: "Попапы и уведомления",
        docs: "Редактор документов",
        analytics: "Аналитика трендов",
        plaza: "Клуб Ssulwha",
        wisdom: "Мудрость звезд",
        recommendation: "Пустая полка",
        charge: "Звездная Станция", // Added
        guide: "Руководство",
        "whats-new": "Что нового",
        invite: "Пригласить друзей",
        about: "О сервисе",
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        report: "Центр жалоб",
        "app-setting": "Настройки приложения",
        login: "Войти / Регистрация",
        logout: "Выйти",
        MyPage: "Моя страница",
        notice: "Уведомления",
        proposal: "Предложения",
        settings: "Настройки",
        language: "Язык"
    },
    modal: {
        translate_title: "Выбор языка",
        translate_placeholder: "Пожалуйста, выберите язык для перевода.",
        translate_start: "Перевести"
    },
    msg: {
        welcome_beta: "Добро пожаловать в бета-версию платформы Mirinae.",
        login_required: "Войдите, чтобы открыть больше историй.",
        login_btn: "Войти / Регистрация"
    },
    profile: {
        follow: "Подписаться",
        following: "Подписан",
        mypage: "Моя страница",
        followers: "Подписчики",
        following_count: "Подписки",
        bio_empty: "Нет описания.",
        works: "Работы",
        feed: "Лента",
        guestbook: "Гостевая",
        works_empty: "Нет зарегистрированных работ.",
        works_error: "Ошибка загрузки работ",
        feed_empty: "Нет публикаций.",
        feed_error: "Ошибка загрузки ленты.",
        feed_error_detail: "Идет создание индекса или ошибка сети.",
        follow_error: "Ошибка подписки."
    },
    support: {
        title: "Служба поддержки 1:1",
        input_placeholder: "Введите ваш запрос...",
        empty_state_title: "Нет истории консультаций.",
        empty_state_desc: "Спрашивайте нас о чем угодно в любое время!",
        status_received: " • Получено",
        auto_reply: "Ваш запрос получен. Мы ответим в порядке очереди. Пока что наслаждайтесь Ssulwha World.",
        send_fail: "Не удалось отправить сообщение"
    },
    author: {
        apply_title: "Заявка на автора",
        apply_desc: "Поделитесь своей историей с миром. Оставьте краткое представление и портфолио, мы свяжемся с вами после проверки.",
        email_label: "Email",
        email_placeholder: "Введите контактный email",
        email_hint: "Мы можем связаться с вами по поводу результатов одобрения и контрактов.",
        intro_label: "О себе",
        intro_placeholder: "Пожалуйста, представьтесь (Опыт писательства, стиль и т.д.)",
        portfolio_label: "Портфолио (Необязательно)",
        submit_btn: "Подать заявку",
        email_required: "Пожалуйста, введите ваш email.",
        intro_required: "Пожалуйста, введите информацию о себе.",
        submitting: "Отправка...",
        submit_success: "Заявка на автора отправлена."
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "Библиотека пуста",
        empty_desc: "Купленные или просмотренные работы появятся здесь.",
        explore_btn: "Обзор работ",
        select_hint: "Выберите работу, чтобы просмотреть список.",
        total_episodes: "Всего {n} эпизодов"
    },
    badge: {
        best_reviewer: "Топ Рецензент",
        top_author: "Топ Автор",
        vip: "VIP",
        donation_king: "Король донатов",
        hall_of_fame: "Зал Славы"
    },
    tab: {
        works: "Работы",
        feed: "Ssulwha (Feed)",
        guestbook: "Гостевая"
    },
    tag: {
        fantasy: "Фэнтези",
        romance: "Романтика",
        martial_arts: "Боевые искусства",
        drama: "Драма",
        slice_of_life: "Повседневность",
        comedy: "Комедия",
        thriller: "Триллер",
        school: "Школа",
        munchkin: "Манчкин",
        regression: "Возвращение",
        possession: "Одержимость",
        system: "Система",
        growth: "Развитие",
        revenge: "Месть",
        heart: "Сердце",
        horror: "Ужасы",
        sport: "Спорт",
        history: "Альт. история"
    },
    guestbook: {
        title: "Гостевая",
        input_placeholder: "Оставьте сообщение поддержки!",
        secret: "Секрет",
        submit: "Отпр.",
        empty: "Оставьте первое сообщение! 👣",
        secret_content: "Это секретное сообщение.",
        delete_confirm: "Вы уверены?",
        reply: "Ответ",
        reply_placeholder: "Написать ответ...",
        reply_delete_confirm: "Удалить ответ?",
        confirm_delete_reply: "Удалить этот ответ?",
        submit_error: "Ошибка отправки: ",
        emoji_error: "Ошибка загрузки эмодзи"
    },
    pwa: {
        install_title: "Установить",
        install_desc: "Работает быстрее и лучше.",
        install_btn: "Установить",
        later_btn: "Позже",
        ios_guide_title: "Установить на iPhone",
        ios_guide_desc: "Наслаждайтесь полноэкранным режимом.",
        ios_step1: "Нажмите 'Поделиться'",
        ios_step2: "Выберите 'На экран домой'",
        update_title: "Новая версия ({version})!",
        update_title_v2: "Доступна новая версия!",
        update_desc: "Обновите для новых функций.",
        update_btn: "Обновить",
        updating: "Обновление...",
        offline_title: "Вы офлайн",
        offline_desc: "Проверьте интернет.",
        copy_success: "Скопировано",
        copy_fail: "Ошибка копирования"
    },
    settings: {
        title: "Настройки приложения",
        general: "Общие",
        push_title: "Push-уведомления",
        push_desc: "Получать уведомления об обновлениях",
        app_info: "Информация о приложении",
        current_version: "Текущая версия",
        danger_zone: "Опасная зона",
        delete_account_title: "Удалить аккаунт (Вернуться в реальность)",
        delete_account_desc: "Все данные будут удалены и не подлежат восстановлению.",
        delete_account_button: "Вернуться в реальность"
    },
    proposal: {
        title: "Мудрость Звезд",
        desc: "Ваша сияющая мудрость расширяет вселенную.",
        label_title: "Заголовок предложения",
        placeholder_title: "Введите суть вашей идеи",
        label_content: "Подробности",
        placeholder_content: "Свободно делитесь своими идеями. Чем конкретнее, тем лучше!",
        btn_submit: "Отправить Мудрость",
        success_title: "Мудрость Получена",
        success_desc: "Мудрость {name} была получена.<br>Спасибо за ваш ценный отзыв."
    },
    report: {
        title: "Центр жалоб",
        category_label: "CATEGORY",
        content_label: "CONTENT",
        url_label: "RELATED URL",
        categories: {
            general: "Общий вопрос / Другое",
            spam: "Спам / Неуместная реклама",
            abuse: "Оскорбления / Язык вражды",
            adult: "Контент для взрослых / Вредно для несовершеннолетних",
            bug: "Системная ошибка / Баг"
        },
        placeholder_content: "Пожалуйста, опишите проблему подробно.",
        btn_submit: "Отправить жалобу",
        warning: "Ложные жалобы могут привести к ограничениям обслуживания.",
        success_title: "Жалоба отправлена",
        success_desc: "Мы рассмотрим и примем меры быстро.<br>Спасибо за вашу жалобу.",
        login_required: "Вы должны войти, чтобы подать жалобу.",
        submit_success: "Жалоба успешно отправлена.\nПожалуйста, проверьте в админ-центре...",
        error: "Ошибка при отправке жалобы",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "Настройка системы",
        desc: "Мы точно настраиваем компас,<br>чтобы помочь вашему путешествию.",
        wait: "Пожалуйста, подождите немного."
    },
    viewer: {
        settings_title: "Настройки аудио/прокрутки",
        bgm_volume: "Громкость BGM",
        bgm_off: "Без BGM",
        auto_speed: "Скорость авто",
        settings_btn: "Настройки",
        translate_btn: "AI Перевод",
        tts_btn: "TTS Чтение",
        bgm_btn: "BGM",
        top_btn: "Наверх",
        auto_play: "Авто-слайд",
        auto_scroll: "Авто-прокрутка",
        start_auto: "Авто-воспроизведение",
        stop_auto: "Остановлено",
        tts_warn: "Примечание: TTS читает на языке оригинала (корейском)."
    },
    login: {
        subtitle: "Где ваше воображение становится реальностью",
        btn_google: "Продолжить с Google",
        or: "ИЛИ",
        label_email: "Эл. почта",
        label_password: "Пароль",
        btn_email_login: "Войти через эл. почту",
        btn_email_signup: "Регистрация через эл. почту",
        msg_no_account: "Нет аккаунта?",
        msg_has_account: "Уже есть аккаунт?",
        btn_signup: "Регистрация",
        btn_login: "Войти",
        msg_processing: "Обработка...",
        msg_email_sent: "Письмо с подтверждением отправлено. Пожалуйста, проверьте и войдите.",
        err_invalid_auth: "Неверный email или пароль.",
        err_email_in_use: "Email уже используется.",
        err_default: "Произошла ошибка."
    },
    terms: {
        title: "Иммиграционный контроль",
        desc: "Добро пожаловать в мир SSULWHA.<br>Пожалуйста, примите условия использования.",
        required: "[Обязательно]",
        optional: "[Необязательно]",
        label_terms: "Условия использования",
        label_privacy: "Политика конфиденциальности",
        label_marketing: "Согласие на маркетинг",
        btn_start: "Начать",
        btn_processing: "Обработка..."
    },
    main: {
        banner_welcome: "✨ Исследуйте мир SSULWHA сегодня!",
        search_placeholder: "Поиск работ, авторов, тегов...",
        hall_of_fame: "Зал славы (Weekly Best)",
        hall_of_fame_locked: "Зал славы доступен только для членов",
        hall_of_fame_desc: "Кто самый активный пользователь на этой неделе? Войдите, чтобы увидеть рейтинг!",
        login_btn: "Войти",
        todays_pick: "Выбор дня",
        continue_reading: "Продолжить чтение",
        trending: "В тренде",
        new_arrivals: "Новинки",
        all_works: "Все работы",
        tag_cloud: "По тегам",
        filter_all: "Все",
        filter_webtoon: "Вебтун",
        filter_webnovel: "Веб-новелла",
        realtime_club: "Клуб Ссульхва в реальном времени",
        enter_club: "Войти",
        be_the_first: "Запустите первую звезду!",
        go_to_plaza: "Перейти на площадь",
        search_results: "Результаты поиска: '{query}'",
        search_no_results: "Результатов не найдено.",
        search_try_other: "Попробуйте другие ключевые слова.",
        splash_loading: "Вход в мир Ссульхва...",
    },
    mypage: {
        tab_library: "Библиотека",
        tab_history: "История",
        tab_activity: "Активность",
        tab_likes: "Избранное",
        tab_wallet: "Кошелек",
        tab_settings: "Настройки",
        no_activity: "Нет активности.",
        go_to_plaza: "Перейти на площадь",
        followers: "Подписчики",
        following: "Подписки",
        edit_profile_tooltip: "Ред. профиль",
        role_author: "Автор",
        role_reader: "Читатель",
        role_admin: "Админ",
        author_pending: "⏳ Ожидание одобрения",
        btn_studio: "Студия авторов",
        btn_apply_author: "Стать автором",
        default_bio: "Введите краткую информацию.",
        menu_edit_profile: "Редактировать профиль",
        menu_public_profile: "Публичный профиль",
        current_version: "Current Version",
        invite_title: "Пригласить",
        invite_reward: "Награда +500P",
        invite_desc: "Поделитесь ссылкой. Вы и ваш друг получите по 500P!",
        invited_count: "Приглашено друзей",
        unit_people: "чел.",
        edit_profile_title: "Редактирование профиля",
        label_photo: "Фото профиля",
        btn_upload: "Загрузить",
        btn_random: "Случайно",
        placeholder_photo_url: "Или URL изображения",
        label_nickname: "Никнейм",
        label_bio: "Био",
        placeholder_bio: "Кратко о себе"
    },

    plaza: {
        title: "Клуб Ссульхва",
        subtitle: "Эмоциональное пространство общения для поколения Z",
        btn_sync: "⚡ Синхр. коммент. (Admin Only)",
        composer_placeholder_init: "Какую историю вы хотите запустить в эту вселенную?",
        composer_placeholder_thread: "Напишите продолжение истории...",
        composer_placeholder_quote: "Оставьте свои мысли об этой истории...",
        btn_add_thread: "Добавить тред",
        btn_submit: "Запустить звезду",
        btn_submit_quote: "Цитировать",
        btn_submitting: "Загрузка...",
        quote_suffix: " цитирует"
    },
    recommendation: {
        loading_title: "Читаем вашу траекторию...",
        loading_desc: "Соединяем ваши прошлые шаги и звезды, где вы останавливались",
        fallback_title: "Созвездие <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>пока видно слабо.",
        fallback_desc: "Но не волнуйтесь. <br>Мы подобрали сияющие истории, которые осветили ночи многих других.<br><span class=\"text-sm opacity-70 mt-1 block\">Когда ваших следов станет больше, мы найдем орбиту только для вас.</span>",
        personal_title: "Книжная полка <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>История для следующей ячейки",
        personal_desc: "Мы нашли 5 звезд, резонирующих с вашим вкусом.",
        label_empty_shelf: "Пустая полка (The Empty Shelf)",
        btn_refresh: "Другие рекомендации",
        error_title: "Соединение нестабильно",
        btn_retry: "Повторить",
        empty_data_title: "Недостаточно данных",
        btn_browse: "Обзор произведений",
        // Widget Specific
        widget_title: "Ищете следующую<br>книгу?",
        widget_desc: "Мы подобрали 5 произведений на основе вкуса {name}.",
        widget_desc_guest: "Мы подобрали 5 произведений на основе вашего вкуса.",
        btn_check: "Посмотреть"
    },
    star_station: {
        title: "Звездная Станция",
        subtitle: "Наслаждайтесь произведениями свободнее.",
        my_stars: "Мои Звезды",
        history_tab: "История",
        products_tab: "Товары",
        payment_method: "Способ оплаты",
        btn_charge: "Пополнить",
        history_empty: "Нет истории пополнений.",
        product_names: {
            stardust: "Звездная пыль",
            shooting_star: "Падающая звезда",
            little_bear: "Малая Медведица",
            silver_river: "Серебряная Река",
            galaxy_master: "Мастер Галактики",
            star_maker: "Создатель Звезд"
        }
    },
    studio: {
        title: "Творческая Студия",
        desc: "Пространство для вашего бесконечного воображения.",
        dashboard: "Дашборд",
        series: "Управление Сериями",
        statistics: "Статистика",
        profit: "Расчеты",
        guide: "Руководство Автора",
        new_series: "Новая серия",
        edit_series: "Редактировать Серию",
        new_episode: "Новый Эпизод",
        edit_episode: "Редактировать Эпизод",
        open_menu: "Открыть меню",
        exit: "Выход",
        lab_badge: "LAB",
        lab_title: "Лаборатория Да Винчи",
        lab_desc: "Откройте новый мир творчества с ИИ.",
        total_views: "Просмотры",
        total_likes: "Лайки",
        total_followers: "Подписчики",
        weekly_performance: "Недельная статистика",
        views_trend_7d: "Тренд просмотров (7 дн.)",
        live_data: "LIVE",
        my_series_list: "Мои работы",
        total_series_count: "Всего {n} работ",
        empty_series_title: "Начните новую историю",
        empty_series_desc: "Раскройте свое воображение миру.",
        btn_editor: "Редактор",
        btn_settings: "Настройки",
        btn_delete: "Удалить",
        delete_modal_title: "Удалить серию",
        create_first_episode: "Создайте свой первый эпизод!",
        create_first_episode_desc: "Нажмите кнопку Новый эпизод, чтобы начать.",
        last_updated: "Последнее обновление: {date}",
        delete_episode_title: "Удалить эпизод",
        delete_episode_content: "Вы уверены, что хотите удалить эпизод '{title}'?",

        // Toolbar
        bold: "Жирный",
        italic: "Курсив",
        highlight_red: "Выделить (Красный)",
        highlight_blue: "Выделить (Синий)",
        save_preserve_status: "Сохранить (Сохранить статус)",
        delete_modal_content: "Вы уверены, что хотите удалить '{title}'? Это действие нельзя отменить."
    },
    editor: {
        davinci_editor: "Редактор DaVinci",
        webnovel_editor: "Редактор Веб-новелл",
        webtoon_editor: "Редактор Вебтунов",
        episode_title: "Название Эпизода",
        placeholder_title: "Введите название эпизода",
        content: "Содержание",
        placeholder_content: "Пишите вашу историю здесь...",
        author_note: "Заметка Автора",
        placeholder_note: "Слово вашим читателям...",
        upload_image: "Загрузить Изображение",
        upload_cover: "Загрузить Обложку",
        save_draft: "Сохранить Черновик",
        publish: "Опубликовать",
        ai_analysis: "AI Анализ",
        ai_recommend: "AI Рекомендация",
        tags: "Теги",
        placeholder_tags: "Добавьте теги (через запятую)",
        preview: "Предпросмотр",
        cover_image: "Cover Image",
        cover_url: "Cover URL",
        series_status: "Series Status",
        admin_info: "Admin Info",
        format: "Format",

        publish_now: "Опубликовать",
        settings: "Настройки",
        episode_prefix: "Эпизод",
        draft_mode_title: "Режим Черновика",
        draft_mode_private_desc: "Этот эпизод в настоящее время скрыт.",
        display_mode: "Режим Отображения",
        mode_webtoon: "Вебтун (Скролл)",
        mode_comic: "Комикс (Страница)",
        mode_insta: "ИнстаТун",
        mode_desc: "Оптимизирует опыт просмотра.",
        thumbnail: "Миниатюра",
        bgm: "BGM",
        manuscript_images: "Рукопись",
        drag_drop_hint: "Перетащите изображения или Нажмите для загрузки",
        set_draft: "В Черновик",
        save_changes: "Сохранить",
        live_preview: "Live Предпросмотр",
        preview_hint: "Проверьте, как это выглядит на мобильных устройствах.",
        val_webtoon_error: "[Ошибка Режима Вебтун] Изображение слишком широкое (Соотношение: {ratio}).<br>Режим Вебтун требует вертикальной прокрутки (Высота > Ширина * 1.2).<br>Для одиночных страниц используйте режим 'Комикс'.",
        val_comic_error: "[Ошибка Режима Комикс] Неверное соотношение сторон ({ratio}).<br>Разрешенные форматы:<br>- Вертикальная страница (ок. 2:3 до 3:4)<br>- Горизонтальный разворот (Ширина > Высота)<br><br>Длинные полосы прокрутки должны использовать режим 'Вебтун'.",
        val_insta_error: "[Ошибка ИнстаТун] Неверное соотношение сторон ({ratio}).<br>Оптимизация для Instagram требует Квадрат (1:1) или Портрет (4:5).<br>Текущее изображение слишком широкое или высокое.",
        approval_requested: "Запрошено Одобрение",
        approval_desc: "Ваша работа была отправлена на утверждение.\\nОна будет опубликована после проверки администратором.",
        pending_approval: "Ожидание Одобрения",
        saved_to_draft: "Сохранено в Черновик",
        published_start_ai: "Эпизод Опубликован! Запуск AI Анализа...",
        ai_trigger_fail: "Запуск AI Анализа не удался. Пожалуйста, используйте кнопку 'AI Анализ' вручную.",
        save_failed: "Ошибка Сохранения: {e}",
        upload_complete: "Загрузка завершена",
        upload_fail_desc: "Ошибка загрузки изображения. (Сбой генерации URL)\nПожалуйста, проверьте консоль.",
        image_mode_mismatch: "Выбранное изображение не соответствует спецификациям режима {mode}.",
        invalid_format: "Неверный формат",
        mode_change_blocked: "Смена режима заблокирована",
        mode_change_blocked_desc: "Некоторые существующие изображения не соответствуют спецификациям {mode}. Пожалуйста, удалите их и попробуйте снова.",
        processing: "Обработка...",
        tap_nav_hint: "Нажмите по краям для навигации или Прокрутите",
        ai_analyze_title: "Подтвердить AI Анализ",
        ai_analyze_confirm: "Запустить AI Анализ (OCR) на этих изображениях?\\nСуществующие данные анализа будут обновлены.",
        save_required: "Пожалуйста, сначала сохраните эпизод.",
        ai_requesting: "Запрос к AI Серверу... (OCR/SEO)",
        ai_processing_title: "AI Обработка",
        ai_no_items: "Элементы не проанализированы (0).\\n\\n[Детали]\\n{log}",
        diagnosis_report: "Отчет Диагностики",
        ocr_complete: "OCR Завершен: {n} кадров",
        seo_trigger: "Авто-генерация SEO запущена.",
        ai_complete_desc: "Анализ Завершен.\\n- Данные OCR Созданы\\n- Метаданные SEO Ожидают\\n(Отобразятся в ближайшее время)",
        ai_error: "Ошибка AI Обработки",
        ai_fail_msg: "AI Анализ Не Удался: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        saved: "Сохранено",
        complete: "Готово",
        ai_analyze_btn: "ИИ Анализ",
        ai_analyzing: "Анализ...",
        series_info: "Инфо о серии (Upload)",
        series_title: "Название серии",

        admin_readonly: "Только админ (Read Only)",
        chapters: "Список глав",
        add_chapter: "Добавить главу",
        delete_chapter_confirm: "Удалить эту главу?",
        content_body: "Текст",
        load_txt: "Загрузить TXT",
        text_too_short: "Текст слишком короткий.",
        upload_cover_fail: "Ошибка загрузки обложки",
        create_series: "Создать серию",
        edit_series: "Редактировать серию",
        basic_info: "Основная инфо",
        episode_mgmt: "Управление эпизодами",
        compliance: "Соответствие (Compliance)",
        age_rating: "Возрастной рейтинг",
        age_guide: "Руководство",
        is_ai: "Использован ИИ контент",
        desc_placeholder: "Введите описание сюжета...",


        format_locked: "Блокировано",
        webtoon: "Вебтун (Webtoon)",
        webnovel: "Веб-новелла (Webnovel)",
        cinenovel: "Сине-новелла (Cine-Novel)",
        admin_id: "ID Код (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",
        upload_fail: "Upload Failed: ",
        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",


        series_info_upload: "Series Info (Upload)",
        cover_upload_fail: "Cover Upload Failed: ",
        save_success: "Saved",
        publish_confirm: "Confirm Publish",

        episode_list: "Список эпизодов",
        status_published: "Опубликовано",
        status_draft: "Черновик",
        edit_detail_guide: "Edit details in editor",
        refreshing_list: "Refreshing list...",
        load_fail: "Load failed: ",
        no_cover: "No Cover",
        badge_ai: "AI Generated",
        no_episodes: "No episodes.",



        select_chapter: "Select a chapter",
        episode_placeholder: "ex) Ep. 1",
        bgm_placeholder: "Suno AI URL...",

        ai_analysis_fail: "AI Analysis Failed: ",
        save_fail: "Save Failed: ",
        back_to_list: "Back to List",
        bold: "Bold",
        italic: "Italic",
        highlight_red: "Highlight (Red)",
        highlight_blue: "Highlight (Blue)",
        save_preserve_status: "Save (Preserve Status)",
        new_episode: "New Episode",
        edit: "Edit",
        delete: "Delete",

        public_toggle: "Public",
        private_toggle: "Private",
        bgm_suno_label: "BGM Settings",
        txt_upload: "Upload TXT",
        content_placeholder: "Enter content...",
        note_placeholder: "Author's note...",
        ai_analysis_complete: "AI Analysis Complete",
        recommend_keywords: "Keywords",
        hook: "Hook",
        analysis_saved: "Data saved.",
        analysis_fail: "Analysis failed.",
        analysis_short: "Content too short.",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "Blocks minors.",



        davinci_lock_desc: "Режим Да Винчи (Cine-Novel) в бета-тесте.<br>Доступ только для <strong>Администраторов</strong> из-за нестабильности.<br><div class='mt-3 text-rose-400 font-bold'>Скоро.</div>",
        preview_preparing: "Подготовка превью...",

        publish_settings: "Publish Settings",
        ai_analyze_local: "AI Context Analysis",
        ai_confirm: "AI Confirmation",
    },

    rating_guide: {
        title: "Content Rating Guide",
        all_title: "All Ages",
        all_desc: "Content suitable for all ages.<br>No or very mild violence, sexual content, or inappropriate language.",
        title_12: "12+ (Teens)",
        desc_12: "May contain mild violence, bad language, or horror.<br>Parental guidance suggested for children under 12.",
        title_15: "15+ (Young Adults)",
        desc_15: "May contain moderate violence, strong language, or mature themes.<br>May portray criminal behavior or social taboos.",
        title_19: "19+ (Adults Only)",
        desc_19: "Contains explicit sexual content, extreme violence, or abusive language.<br><strong class='text-red-500'>Legally restricted to adults 19+. Identity verification required.</strong>",
        disclaimer: "* Rating is the author's responsibility. False ratings may lead to forced changes or penalties.",
        confirm: "Understood"
    },
    davinci: {
        episode_settings: "Настройки эпизода",
        title: "Название",
        thumbnail: "Миниатюра",
        bgm: "BGM",
        add_block: "Добавить блок",
        text_block: "Текст",
        image_block: "Изображение",
        upload_image: "Загрузить фото",
        upload_thumb: "Загрузить миниатюру",
        upload_success: "Загружено",
        bgm_placeholder: "Suno URL или MP3 ссылка",
        tip: "Совет:",
        drag_tip: "Перетаскивайте блоки для сортировки.",
        save_draft: "Сохранить черновик",
        publish: "Опубликовать",
        saving: "Сохранение...",
        published: "Опубликовано! Доступно читателям.",
        publish_confirm: "Опубликовать? Читатели увидят это.",
        preview_preparing: "Подготовка превью...",
        thumbnail_uploading: "Загрузка миниатюры...",
        thumbnail_applied: "Миниатюра применена",
        guide: {
            title: "Гид по кнопкам",
            save: "Сохранить",
            save_desc: "Сохранить изменения.",
            draft: "Черновик",
            draft_desc: "Сделать приватным.",
            publish: "Опубликовать",
            publish_desc: "Сделать публичным. (Видно читателям)",
            auto_save: "Автосохранение",
            auto_save_on: "ВКЛ (3с)",
            auto_save_desc: "Автоматическое сохранение каждые 3 секунды."
        }
    },
    intro: {
        slogan: "Человеческое Творчество, Масштабируемость ИИ",
        hero_title: "Вавилонская рыбка",
        hero_subtitle: "для Сине-новелл.",
        status_active: "Механизм перевода активен",
        status_cine: "Формат Сине-новеллы",
        desc_1: "Читайте корейские IP мгновенно на <span class='text-white font-bold mx-1'>10 языках</span> с помощью нашего неразрушающего ИИ.",
        desc_2: "Испытайте <span class='text-white font-bold mx-1'>первый в мире гибридный формат</span>, где визуальные эффекты и романы сливаются воедино.",
        cta_start: "Начать читать бесплатно",
        compare_title: "Разрушающий vs Неразрушающий",
        compare_desc: "Мы никогда не трогаем оригинальные пиксели. Посмотрите разницу.",
        compare_old: "Старый метод (Белая рамка)",
        compare_new: "Движок Ssulwha (R.A.P.S)",
        white_box_removed: "Белые рамки удалены",
        format_title: "За пределами статических изображений",
        format_desc: "Визуальные эффекты вебтуна. Глубина романа. Кинематографическое погружение.",
        geo_title: "Рост, управляемый ИИ",
        geo_desc: "Мы не занимаемся маркетингом. Наш ИИ делает это.",
        term_log_1: "Анализ контента...",
        term_log_2: "Извлечение ключевых слов...",
        term_log_3: "Внедрение метаданных JSON-LD...",
        term_log_4: "Органический рост +300%",

        // Missing Keys Added
        slider_old_title: "Старый метод",
        slider_old_desc: "БЛОКИРУЕТ ИСКУССТВО",
        slider_new_title: "Движок Ssulwha (R.A.P.S)",
        slider_new_desc_1: "\"Так и должно быть.\"",
        slider_new_desc_2: "Текст плавает естественно, сохраняя произведение искусства.",

        phone_analyzing: "Анализ...",
        phone_detected: "Обнаружено",
        phone_text_1: "Это моя судьба?",
        phone_cine_ep: "СИНЕ-НОВЕЛЛА ЭП.01",
        phone_cine_text_1: "Неоновые огни мерцали, отражаясь в его холодных глазах.",
        phone_cine_text_2: "\"Это не просто перевод,\" — пробормотал он. — \"Это новая реальность.\"",

        footer_copyright: "Работает на движке R.A.P.S."
    }
};
